function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function updateCart() {
    document.documentElement.dispatchEvent(
    new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
}

function subtotalLinePrice(el, color) {
    var variantName = '[data-color="' + color + '"]';
    var items = el.closest('.c-product-variant__wrapper').find(variantName);
    var sum = 0;
    for (let i = 0; i < items.length; i++) {
    	var priceSubtotal = $(items[i]).attr('data-product-price-total');
    	var priceSubtotalFloat = parseFloat(priceSubtotal);
    	sum = sum + priceSubtotalFloat;
    }
    return sum;
}

function  subtotalLineUnid(el, color) {
    var variantName = '[data-color="' + color + '"]';
    var items = el.closest('.c-product-variant__wrapper').find(variantName);
    var sum = 0;
    for (let i = 0; i < items.length; i++) {
    	var priceSubtotal = $(items[i]).attr('data-product-quantity');
    	var priceSubtotalFloat = parseFloat(priceSubtotal);
    	sum = sum + priceSubtotalFloat;
    }
    return sum;
}

function  subtotalLineUnidSize(el, size) {
    var variantName = '[data-name="' + size + '"]';
    var items = el.closest('.c-product-variant__wrapper').find(variantName);
    var sum = 0;
    for (let i = 0; i < items.length; i++) {
    	var priceSubtotal = $(items[i]).attr('data-product-quantity');
    	var priceSubtotalFloat = parseFloat(priceSubtotal);
    	sum = sum + priceSubtotalFloat;
    }
    return sum;
}

function totalLine(el) {
    var items = el.closest('.c-product-variant__wrapper').find('[js-line-price-subtotal]');
    var sum = 0;
    for (let i = 0; i < items.length; i++) {
    	var priceTotal = $(items[i]).attr('data-line-price-subtotal');
    	var priceTotalFloat = parseFloat(priceTotal);
    	sum = sum + priceTotalFloat;
    }
    return sum;
}

function totalLineUnid(el) {
    var items = el.closest('.c-product-variant__wrapper').find('[js-line-unidades-subtotal]');
    var sum = 0;
    for (let i = 0; i < items.length; i++) {
    	var priceTotal = $(items[i]).attr('data-line-unidades-total');
    	var priceTotalFloat = parseFloat(priceTotal);
    	sum = sum + priceTotalFloat;
    }
    return sum;
}

function totalLineUnidSize(el) {
    var items = el.closest('.c-product-variant__wrapper').find('[js-line-unidades-size-subtotal]');
    var sum = 0;
    for (let i = 0; i < items.length; i++) {
    	var priceTotal = $(items[i]).attr('data-line-unidades-size-total');
    	var priceTotalFloat = parseFloat(priceTotal);
    	sum = sum + priceTotalFloat;
    }
    return sum;
}

function resetTotalLine(el) {
    var items = el.closest('.c-product-variant__wrapper').find('[js-line-price-subtotal]');
    for (let i = 0; i < items.length; i++) {
    	$(items[i]).attr('data-line-price-subtotal', 0);
    	$(items[i]).empty().append('$0.00');
    }
    var itemsUnid = el.closest('.c-product-variant__wrapper').find('[js-line-unidades-subtotal]');
    for (let i = 0; i < itemsUnid.length; i++) {
    	$(itemsUnid[i]).attr('data-line-unidades-total', 0);
    	$(itemsUnid[i]).empty().append(0);
    }
    var itemsUnidSize = el.closest('.c-product-variant__wrapper').find('[js-line-unidades-size-subtotal]');
    for (let i = 0; i < itemsUnidSize.length; i++) {
    	$(itemsUnidSize[i]).attr('data-line-unidades-size-total', 0);
    	$(itemsUnidSize[i]).empty().append(0);
    }
}

function resetButton(el) {
	el.closest('.c-product-variant__wrapper').find('[js-total-price-cart]').empty().append('$0.00');
	el.closest('.c-product-variant__wrapper').find('[js-total-unidades-cart]').empty().append(0);

    var items = el.closest('.c-product-variant__wrapper').find('[js-line-price-subtotal]');
    for (let i = 0; i < items.length; i++) {
    	$(items[i]).attr('data-line-price-subtotal', 0);
    	$(items[i]).empty().append('$0.00');
    }
    var itemsUnid = el.closest('.c-product-variant__wrapper').find('[js-line-unidades-subtotal]');
    for (let i = 0; i < itemsUnid.length; i++) {
    	$(itemsUnid[i]).attr('data-line-unidades-total', 0);
    	$(itemsUnid[i]).empty().append(0);
    }
    var itemsUnidSize = el.closest('.c-product-variant__wrapper').find('[js-line-unidades-size-subtotal]');
    for (let i = 0; i < itemsUnidSize.length; i++) {
    	$(itemsUnidSize[i]).attr('data-line-unidades-size-total', 0);
    	$(itemsUnidSize[i]).empty().append(0);
    }
    var itemsOptions = el.closest('.c-product-variant__wrapper').find('.js-product-variant-option.active');
    for (let i = 0; i < itemsOptions.length; i++) {
		$(itemsOptions[i]).removeClass('active');
		$(itemsOptions[i]).attr('data-product-quantity', 0);
		$(itemsOptions[i]).attr('data-product-price-total', 0);
		$(itemsOptions[i]).find('#quantity-variants').val('');
		$(itemsOptions[i]).find('.js-product-message').empty();
    }
}

document.addEventListener('DOMContentLoaded', () => {
	/* Multiply Product - Add to cart */
	/* -------------------------------------------------------------------------------------- */
	$('.js-add-cart-multiply').on('click', function(event) {
		event.preventDefault();
		var el = $(this);
		var items = el.closest('.c-product-variant__wrapper').find('.js-product-variant-option.active');
      	var getBuyingRate = localStorage.getItem('buyingRate');	
        el.find('[data-add-to-cart-text]').addClass('d-none');
		el.find('[data-loader]').removeClass('d-none');
		if (items.length > 0) {
			$.getJSON('/cart.js').then(
				function(cart) {
					for (let i = 0; i < items.length; i++) {
						var quantity = $(items[i]).attr('data-product-quantity');
						var idProduct = $(items[i]).attr('data-product-id');
						var preventa = $(el).attr('data-order');
						var group = $(el).attr('data-product-group');
                        if (cart.items == 0 || getBuyingRate == preventa) {
    						if (quantity > 0) {
    							$.ajax({
    								url: "/cart/add",
    								type: "post",
    								data: {
    									id: idProduct,
    									quantity: quantity,
    									properties: {
    										ORDER: preventa,
    										GROUP: group
    									}
    								},
    								dataType: 'json',
    								async: false,
    								success: function(response) {
    									/* Reset */
    									$(items[i]).removeClass('active');
    									$(items[i]).attr('data-product-quantity', 0);
    									$(items[i]).attr('data-product-price-total', 0);
    									$(items[i]).find('#quantity-variants').val('');
    									$(items[i]).find('.js-product-message').empty();
    									el.closest('.c-product-variant__wrapper').find('[js-total-price-cart]').empty().append('$0.00');
    									el.closest('.c-product-variant__wrapper').find('[js-total-unidades-cart]').empty().append(0);
    									resetTotalLine(el);
    									/* Inventory */
    									var maxInventory = parseInt($(items[i]).find('#quantity-variants').attr('inventory'));
    									if (response.quantity <= maxInventory) {
    										var calcInventoryLabel = maxInventory - response.quantity;
    										$(items[i]).find('[js-product-max-inventory]').empty().append(calcInventoryLabel);
    										$(items[i]).find('#quantity-variants').attr('max', calcInventoryLabel);
    									}else if (response.quantity > maxInventory){
    										$(items[i]).find('[js-product-max-inventory]').empty().append(0);
    										$(items[i]).find('#quantity-variants').attr('max', 0);
    									}
    									/* What table is displayed? */
    									localStorage.setItem('buyingRate', preventa);
    									if (preventa == 'Entrega inmediata') {
    										$('[data-order-option="Preventa"]').css('display', 'none');
    										if (localStorage.getItem('dontLoad') == null || localStorage.getItem('dontLoad') == true){
    											$('#id-variants-entrega-popup').addClass('active');
    										}
    									}else if(preventa == 'Preventa'){
    										$('[data-order-option="Entrega inmediata"]').css('display', 'none');
    										if (localStorage.getItem('dontLoad') == null || localStorage.getItem('dontLoad') == true){
    											$('#id-variants-preventa-popup').addClass('active');
    										}
    									}
    									if (localStorage.getItem('updatePage') != null || localStorage.getItem('updatePage') == 'false') {
    										localStorage.setItem('updatePage', 'true');
    									}
    									
    								},
    								error: function (err) {
    									$(items[i]).attr('data-product-quantity', 0);
    									$(items[i]).attr('data-product-price-total', 0);
    									el.closest('.c-product-variant__wrapper').find('[js-total-price-cart]').empty().append('$0.00');
    									el.closest('.c-product-variant__wrapper').find('[js-total-unidades-cart]').empty().append(0);
    									$(items[i]).find('.js-product-message').empty().append('No hay suficientes productos');
    									resetTotalLine(el);
    								}
    							})
    						}else if(quantity == 0 ){
    							$.ajax({
    								type: 'POST',
    								url: '/cart/change.js',
    								data: {
    									id: idProduct,
    									quantity: quantity,
    									properties: {
    										ORDER: preventa
    									}
    								},
    								dataType: 'json', 
    								async: false,         
    								success: function(data) {
    									$(items[i]).removeClass('active');
    									$(items[i]).attr('data-product-quantity', 0);
    									$(items[i]).attr('data-product-price-total', 0);
    									$(items[i]).find('#quantity-variants').val('');
    									$(items[i]).find('.js-product-message').empty();
    									el.closest('.c-product-variant__wrapper').find('[js-total-price-cart]').empty().append('$0.00');
    									el.closest('.c-product-variant__wrapper').find('[js-total-unidades-cart]').empty().append(0);
    									resetTotalLine(el);
    								},
    								error: function(response) {
    									$(items[i]).attr('data-product-quantity', 0);
    									$(items[i]).attr('data-product-price-total', 0);
    									el.closest('.c-product-variant__wrapper').find('[js-total-price-cart]').empty().append('$0.00');
    									el.closest('.c-product-variant__wrapper').find('[js-total-unidades-cart]').empty().append(0);
    									$(items[i]).find('.js-product-message').empty().append('No hay suficientes productos');
    									resetTotalLine(el);
    								}
    							});
    						}
                        }
                        if(cart.items != 0 && getBuyingRate != preventa){
                          console.log('Entra');
                          var textBuyingRate = '<p><span>El producto agregado no pertenece a <strong>' + getBuyingRate + '</strong>.</p><p>Solo puedes incluir productos de la misma forma de entrega, para cambiarla unicamente debes vaciar el carrito de compra.</span></p>';
                          $('#id-buying-rate-popup').addClass('active');
                          $('[js-message-buying-rate]').empty().append(textBuyingRate);
                        }
						var lastItem = items[items.length - 1];
						var lastItemID = $(lastItem).attr('data-product-id');
						if (lastItemID == idProduct) {
							el.find('[data-add-to-cart-text]').removeClass('d-none');
							el.find('[data-loader]').addClass('d-none');
							updateCart();
						}
					}
				}
			);
		}
	});

	$('.js-reset-cart-multiply').on('click', function(event) {
		event.preventDefault();
		var el = $(this);
		resetButton(el);
	});

	$('body').on('click', '[js-close-item]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-close'));
		item.removeClass('active');
	});

	$('body').on('keyup, keydown', 'input[type="number"]', debounce(function(){
		var input = $(this),
			variant = input.closest('.js-product-variant-option'),
			inputValue = parseFloat(input.val()),
			maxinputValue = parseFloat(input.attr('max')),
			variantPrice = variant.closest('.js-product-variant-option').attr('data-product-price'),
			variantOptionColor = variant.closest('.js-product-variant-option').attr('data-color');
			variantOptionSize = variant.closest('.js-product-variant-option').attr('data-name');
			variant.addClass('active');
		// Price per variant
		if (isNaN(inputValue) == true) {
			inputValue = 0;
		}
		if (inputValue <= maxinputValue) {
			variant.attr('data-product-quantity', inputValue);
			variant.closest('.js-product-variant-option').find('.js-product-message').empty();
			var priceTotal = variantPrice * inputValue;
			variant.closest('.js-product-variant-option').attr('data-product-price-total', priceTotal);
		}else {
			input.val(maxinputValue);
			variant.attr('data-product-quantity', maxinputValue);
			variant.closest('.js-product-variant-option').find('.js-product-message').empty().append('El valor debe ser menor o igual a ' + maxinputValue);
			var priceTotal = variantPrice * maxinputValue;
			variant.closest('.js-product-variant-option').attr('data-product-price-total', priceTotal);
		}
		// Price per line
		var subTotal = subtotalLinePrice(input, variantOptionColor);
		var selector = '[js-line-price-' + variantOptionColor + ']';
		var subtotalContent = input.closest('.c-product-variant__wrapper').find(selector);
  		subtotalContent.empty().append(new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subTotal/100));
  		subtotalContent.attr('data-line-price-subtotal', subTotal);
  		// Price total cart
  		var totalCart = totalLine(input);
  		var totalCartContent = input.closest('.c-product-variant__wrapper').find('[js-total-price-cart]');
  		totalCartContent.empty().append(new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totalCart/100));
		// Unid per line
		var subUnidTotal = subtotalLineUnid(input, variantOptionColor);
		var selectorUnid = '[js-line-unidades-' + variantOptionColor + ']';
		var subtotalUnidContent = input.closest('.c-product-variant__wrapper').find(selectorUnid);
  		subtotalUnidContent.empty().append(subUnidTotal);
  		subtotalUnidContent.attr('data-line-unidades-total', subUnidTotal);
  		// Price total cart
  		var totalUnidCart = totalLineUnid(input);
  		var totalUnidCartContent = input.closest('.c-product-variant__wrapper').find('[js-total-unidades-cart]');
  		totalUnidCartContent.empty().append(totalUnidCart);
  		// Unid per line size
		var subUnidSizeTotal = subtotalLineUnidSize(input, variantOptionSize);
		var selectorUnidSize = '[js-line-unidades-size-' + variantOptionSize + ']';
		var subtotalUnidSizeContent = input.closest('.c-product-variant__wrapper').find(selectorUnidSize);
  		subtotalUnidSizeContent.empty().append(subUnidSizeTotal);
  		subtotalUnidSizeContent.attr('data-line-unidades-size-total', subUnidSizeTotal);
	},100));

	/* Show popup */
	/* -------------------------------------------------------------------------------------- */
	$('#show-window, #show-window-pre').change(function(){
    	if(this.checked){
        	sessionStorage.setItem('dontLoad', 'true');
    	}
   		else{
        	sessionStorage.setItem('dontLoad', 'false');
   		}
	});
});